import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  OnInit,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxSchedulerComponent,
  DxSchedulerModule,
  DxTooltipComponent,
  DxButtonModule,
  DxCalendarModule,
  DxSpeedDialActionModule,
  DxTooltipModule,
  DxListModule,
  DxCheckBoxModule,
  DxSelectBoxModule, // DKM-5509 Cedric: nikah memuru süzgeci
} from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import { ScreenService } from '../../services/screen.service';
import { ViewType } from 'devextreme/ui/scheduler';
import { DkTakvimService } from './dk-takvim.service';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { CtlGenKisiComponent } from '../controls/ctl-gen-kisi/ctl-gen-kisi.component';
import { CtGenLookupComponent } from '../ct-gen-lookup/ct-gen-lookup.component';
import { CtlGenKontrolComponent } from '../controls/ctl-gen-kontrol/ctl-gen-kontrol.component';
import ArrayStore from 'devextreme/data/array_store';

@Component({
  selector: 'dk2-takvim',
  standalone: true,
  imports: [
    CommonModule,
    DxSchedulerModule,
    DxTooltipModule,
    DxListModule,
    DxCheckBoxModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxCalendarModule,
    DxSpeedDialActionModule,
    CtlGenKisiComponent,
    CtGenLookupComponent,
    CtlGenKontrolComponent,
  ],
  templateUrl: './dk-takvim.component.html',
  styleUrls: ['./dk-takvim.component.scss'],
})
export class DkTakvimComponent implements OnInit {
  @ViewChildren(CtGenLookupComponent) lookups: QueryList<CtGenLookupComponent>;
  @ViewChildren('control') controls: QueryList<ViewChildren>;
  @Input() dataSource: any;
  @Output() onInsert = new EventEmitter<any>();
  @Output() onUpdate = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onChangeStat = new EventEmitter<any>();

  currentDate = new Date();
  currentView: ViewType = 'workWeek';
  selectedAppointment: any;
  // DKM-5069 Clara: Nikah memuru seçiminde pasif (AKTIF_EH='H') memurlar listelenmez; açılan randevunun mevcut memuru
  // pasif olsa da listede kalır. Takvim etiketleri (listDataSourceMemur) tüm memurlarla çalışmaya devam eder.
  private aktifMemurKodlari: Set<number> | null = null;
  memurFiltre = (item: any): boolean => {
    if (!this.aktifMemurKodlari) return true;
    const kod = Number(item?.kod);
    const mevcut = Number(this.selectedAppointment?.data?.nikahMemurKod);
    return this.aktifMemurKodlari.has(kod) || (mevcut > 0 && kod === mevcut);
  };
  public beyanData: any = {};
  /** DKM-5509 Cedric: sol paneldeki nikah memuru süzgeci (ETS_MEMUR.KOD); null → tüm memurlar. */
  memurSuzgec: number | null = null;
  /** Süzgeç seçenekleri: aktif memurlar + yüklü aralıkta randevusu olan pasif memurlar (memurSecenekleriniKur). */
  memurSuzgecSecenekleri: any[] = [];
  private yukluMemurKodlari = new Set<number>();
  private memurSecenekleriniKur(yuklu?: any[]) {
    if (yuklu) this.yukluMemurKodlari = new Set(yuklu.map((t: any) => Number(t.nikahMemurKod)));
    const tumu = this.listDataSourceMemur?.items ?? [];
    const aktif = this.aktifMemurKodlari;
    this.memurSuzgecSecenekleri = !aktif
      ? tumu
      : tumu.filter((m: any) => {
          const kod = Number(m?.kod);
          return aktif.has(kod) || this.yukluMemurKodlari.has(kod) || kod === this.memurSuzgec;
        });
  }
  tasks: DataSource<any> = new DataSource([]);
  listDataSource: DataSource<any> = new DataSource([]);
  listDataSourceMemur:any;
  listDataSourceSalon: any;



  isRightPanelOpen = true;
  isXSmall = this.screen.sizes['screen-small'];
  selectedItems: any[] = [];
  selectAllButtonText = 'Tümünü Seç';
  public memurData :any;
  public salonData:any;

  previousRangeStart: Date | null = null;
  previousRangeEnd: Date | null = null;

  private destroy$ = new Subject<void>();
  private previousMonth: number = this.currentDate.getMonth();
  private previousYear: number = this.currentDate.getFullYear();

  @ViewChild('schedulerRef', { static: false })
  schedulerRef: DxSchedulerComponent;
  @ViewChild('tooltipRef', { static: false }) tooltipRef: DxTooltipComponent;

  constructor(
    private takvimService: DkTakvimService,
    protected screen: ScreenService
  ) {}

  async ngAfterViewInit() {
  // Memur ve salon verilerini yükle
  const memur$ = this.takvimService.getMemurAd();
  const salon$ = this.takvimService.getEtsSalon();

  // forkJoin ile ikisini bekle
  forkJoin([memur$, salon$])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([memurData, salonData]: any) => {
      this.listDataSourceMemur = memurData;
      this.listDataSourceSalon = salonData;
      this.memurSecenekleriniKur(); // DKM-5509 Cedric

      // Tasks yüklendiyse agentLabel ekle
      this.tasks.items().forEach(task => {
        const memur = this.listDataSourceMemur?.items?.find((m: any) => m.kod === task.nikahMemurKod)?.aciklama || '';
        const salon = this.listDataSourceSalon?.items?.find((s: any) => s.kod === task.calendarId)?.aciklama || '';
        const start = task.startDate.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
        const end = task.endDate.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
        const descPart = task.text ? `${task.text} | ` : '';
        task.agentLabel = `${descPart}${start} - ${end} saatine ${memur} Memurun ${salon} salonunda randevusu vardır.`;
        task.salonLabel = salon;
      });

      this.tasks.reload();
    });
}

ngOnInit(): void {
  // DKM-5069 Clara
  // DKM-5509 Cedric: eski hâli — this.takvimService.getAktifMemurKodlari().then((kodlar) => (this.aktifMemurKodlari = kodlar));
  this.takvimService.getAktifMemurKodlari().then((kodlar) => {
    this.aktifMemurKodlari = kodlar;
    this.memurSecenekleriniKur();
  });
   this.takvimService
      .getEtsSalon()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        const items = (data?.items ?? []).map((el: any) => ({
          id: el.kod,
          text: el.aciklama,
        }));
        this.listDataSource = new DataSource(items);
        this.setSelection(items, true); // başlangıçta hepsi seçili
      });

        


    // Ekran değişimi
    this.screen.screenChanged
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ isXSmall }) => {
        this.isXSmall = isXSmall;
        this.repaintScheduler();
      });

    // İlk görev yükleme
   this.dataSource.load().then((originalData: any[]) => {
  this.tasks = new DataSource({
    store: new ArrayStore({
      key: 'id',
      data: this.mapApiListToTasks(originalData ?? [])
    })
  });
  this.memurSecenekleriniKur(originalData?.map((x: any) => ({ nikahMemurKod: x.NikahMemurKod })) ?? []); // DKM-5509 Cedric
  this.repaintScheduler();
});
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // -------------------- UI EVENTS --------------------
  toggleRightPanelOpen(isOpen?: boolean) {
    this.isRightPanelOpen = isOpen ?? !this.isRightPanelOpen;
    this.repaintScheduler();
  }

  onSelectedDateChange(date?: any) {
    this.currentDate = date ?? new Date();
    this.loadTasksForMonth(this.currentDate);
  }

  onCalendarDateChange(date: any) {
    this.currentDate = date;
    this.loadTasksForMonth(this.currentDate);
  }

  onSchedulerDateChange(date: any) {
    this.currentDate = date;
    this.loadTasksForMonth(this.currentDate);
  }

  onCurrentViewChange(view: any) {
    this.currentView = view;
  }

  onAddClick(e: DxButtonTypes.ClickEvent) {
    e.event.stopImmediatePropagation();
  }

  goBack() {
    this.onChangeStat.emit(false);
  }

loadTasksForMonth(date: Date, forceReload = false) {
  const daysBefore = 14;
  const daysAfter = 14;
  const extraDays = 7; // seçilen tarihe eklenen ekstra kontrol

  const newStart = new Date(date);
  newStart.setDate(date.getDate() - daysBefore);

  const newEnd = new Date(date);
  newEnd.setDate(date.getDate() + daysAfter);

  // Seçilen tarihin +7 günü
  const datePlus7 = new Date(date);
  datePlus7.setDate(date.getDate() + extraDays);

  const isDateWithinPreviousRange =
    this.previousRangeStart &&
    this.previousRangeEnd &&
    (
      (date >= this.previousRangeStart && date <= this.previousRangeEnd) ||
      (datePlus7 >= this.previousRangeStart && datePlus7 <= this.previousRangeEnd)
    );

  if (!forceReload && isDateWithinPreviousRange) {
    this.applySelectionFilter();
    return;
  }

  // Yeni aralık ile önceki aralığı güncelle
  this.previousRangeStart = newStart;
  this.previousRangeEnd = newEnd;

  this.takvimService
  .getEtsSalonDetayFilter({ startDate: newStart, endDate: newEnd })
  .load()
  .then((data: any[]) => {
    this.tasks = new DataSource({
      store: new ArrayStore({
        key: 'id',
        data: this.mapApiListToTasks(data ?? [])
      })
    });
    this.memurSecenekleriniKur((data ?? []).map((x: any) => ({ nikahMemurKod: x.NikahMemurKod }))); // DKM-5509 Cedric
    this.repaintScheduler();
    this.applySelectionFilter();
  });
}


  // -------------------- APPOINTMENT INTERACTIONS --------------------
  onAppointmentClick(e: any) {
    this.beyanData = {
      calendarId: e.appointmentData.calendarId,
      nikahMemurKod: e.appointmentData.nikahMemurKod,
      kisiKod: e.appointmentData.kisiKod,
      evlenBeyanKod: e.appointmentData.evlenBeyanKod,
    };
    this.selectedAppointment = {
      data: e.appointmentData,
      target: e.targetElement,
    };
  }

  onAppointmentTooltipShowing(e: any) {
    e.cancel = true;
    const appt = e.appointments?.[0]?.appointmentData;
    if (!appt) return;

    this.beyanData = {
      calendarId: appt.calendarId,
      nikahMemurKod: appt.nikahMemurKod,
      kisiKod: appt.kisiKod,
      evlenBeyanKod: appt.evlenBeyanKod,
    };

    this.selectedAppointment = {
      data: appt,
      target: e.targetElement,
    };
    this.tooltipRef?.instance.show();
  }

  showAppointmentCreationForm(appointment?: any) {
  if (!appointment) {
    this.beyanData = {};
    this.selectedAppointment = null;
  } else {
    this.beyanData = {
      calendarId: appointment.data.calendarId,
      nikahMemurKod: appointment.data.nikahMemurKod,
      kisiKod: appointment.data.kisiKod,
      evlenBeyanKod: appointment.data.evlenBeyanKod,
    };
    this.selectedAppointment = appointment;
  }

  this.schedulerRef?.instance.showAppointmentPopup(
    appointment?.data,
    !appointment
  );
}

  onAppointmentFormOpening(e: any) {
    const form = e.form;
    const appointmentData = e.appointmentData;

    form.itemOption('description', { label: { text: 'Açıklama' } });
    form.itemOption('text', { visible: true });

    let mainGroup;
    try {
      const allItems = form.option('items') || [];
      mainGroup = allItems.find((i: any) => i.name === 'mainGroup');
    } catch {
      mainGroup = form.itemOption('mainGroup');
    }
    if (!mainGroup) return;

    const items = mainGroup.items || [];
    const extraItems = [
      {
        dataField: 'kisiKod',
        colSpan: 2,
        label: { text: 'Kişi Kodu' },
        template: 'kisiKodTemplate',
        editorOptions: { value: appointmentData.kisiKod },
      },
      {
        dataField: 'calendarId',
        label: { text: 'Salon' },
        template: 'calendarIdTemplate',
        editorOptions: { value: appointmentData.calendarId },
      },
      {
        dataField: 'nikahMemur',
        label: { text: 'Nikah Memuru' },
        template: 'nikahMemurKodTemplate',
        editorOptions: { value: appointmentData.nikahMemurKod },
      },
      {
        dataField: 'yapilacakYer',
        label: { text: 'Yapılacak Yer' },
        editorType: 'dxTextBox',
        editorOptions: { value: appointmentData.yapilacakYer },
      },
      {
        dataField: 'evlenBeyanKod',
        label: { text: 'Evlenme Beyan Kodu' },
        template: 'evlenBeyanKodTemplate',
        editorOptions: { value: appointmentData.evlenBeyanKod },
      },
    ];

    extraItems.forEach((item) => {
      if (!items.find((i: any) => i.dataField === item.dataField)) {
        items.push(item);
      }
    });

    const findText = items.find((i: any) => i.dataField === 'text');
    if (findText) items.splice(items.indexOf(findText), 1);

    const exists2 = items.find(
      (i: any) => i.colCountByScreen?.lg === 2 && i.colCountByScreen?.xs === 2
    );
    if (exists2) items.splice(items.indexOf(exists2), 1);

    form.itemOption('mainGroup', 'items', items);

    // DKM-5069 Clara: form şablonu yeniden kullanılırsa memur süzgeci açılan randevuya göre tazelensin
    setTimeout(() => this.lookups?.find((l) => l.lookUpType === 'ETS_MEMUR_AD')?.getDataSource());
  }

  editSelectedAppointment() {
    if (!this.selectedAppointment?.data) return;

    this.showAppointmentCreationForm(this.selectedAppointment);
    this.tooltipRef?.instance.hide();

    const item = this.normalizeAppointmentDates(this.selectedAppointment.data);
    const payload = this.buildAppointmentPayload(item, {
      calendarId: Number(this.beyanData.calendarId),
      nikahMemurKod: Number(this.beyanData.nikahMemurKod),
      kisiKod: Number(this.beyanData.kisiKod),
      evlenBeyanKod: Number(this.beyanData.evlenBeyanKod),
    });

    this.onUpdate.emit(payload);

    const memur = this.listDataSourceMemur?.items?.find((m: any) => m.kod === payload.NikahMemurKod)?.aciklama || '';
    const salon = this.listDataSourceSalon?.items?.find((s: any) => s.kod === payload.SalonKod)?.aciklama || '';
    const start = item.startDate.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    const end = item.endDate.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    const descPart = item.description ? `${item.description} | ` : '';

    item.agentLabel = `${descPart}${start} - ${end} saatine ${memur} Memurun ${salon} salonunda randevusu vardır.`;
    item.salonLabel = salon;
    this.tasks.store().update(item, {
      description: item.description,
      text: item.description,
      calendarId: payload.SalonKod,
      startDate: item.startDate,
      endDate: item.endDate,
      nikahMemurKod: payload.NikahMemurKod,
      kisiKod: payload.KisiKod,
      yapilacakYer: item.yapilacakYer,
      evlenBeyanKod: payload.EvlenBeyanKod,
      eskiKisiKod: item.eskiKisiKod,
      rezervTarih: payload.RezervTarih,
      agentLabel: item.agentLabel,
      salonLabel: item.salonLabel,
    })
    
    this.repaintScheduler();
  }
appointmentAdded(e: any) {
  const item = this.normalizeAppointmentDates(e.appointmentData);

  const payload = this.buildAppointmentPayload(item, {
    calendarId: Number(this.beyanData.calendarId),
    nikahMemurKod: Number(this.beyanData.nikahMemurKod),
    kisiKod: Number(this.beyanData.kisiKod),
    evlenBeyanKod: Number(this.beyanData.evlenBeyanKod),
  });

  this.onInsert.emit(payload);

  setTimeout(() => {
    this.loadTasksForMonth(this.currentDate,true);
  }, 1000);
}

  appointmentUpdated(e: any) {
    const item = this.normalizeAppointmentDates(e.appointmentData);
    const payload = this.buildAppointmentPayload(item);

    this.onUpdate.emit(payload);

    const memur = this.listDataSourceMemur?.items?.find((m: any) => m.kod === payload.NikahMemurKod)?.aciklama || '';
    const salon = this.listDataSourceSalon?.items?.find((s: any) => s.kod === payload.SalonKod)?.aciklama || '';
    const start = item.startDate.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    const end = item.endDate.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    const descPart = item.description ? `${item.description} | ` : '';

    item.agentLabel = `${descPart}${start} - ${end} saatine ${memur} Memurun ${salon} salonunda randevusu vardır.`;
    item.salonLabel = salon;


    this.tasks.store().update(item, {
      description: item.description,
      text: item.description,
      calendarId: payload.SalonKod,
      startDate: item.startDate,
      endDate: item.endDate,
      nikahMemurKod: payload.NikahMemurKod,
      kisiKod: payload.KisiKod,
      yapilacakYer: item.yapilacakYer,
      evlenBeyanKod: payload.EvlenBeyanKod,
      eskiKisiKod: item.eskiKisiKod,
      rezervTarih: payload.RezervTarih,
      agentLabel: item.agentLabel,
      salonLabel: item.salonLabel,
    });

    this.repaintScheduler();
  }

  appointmentDeleted(e: any) {
    const item = this.normalizeAppointmentDates(e.appointmentData);
    const payload = this.buildAppointmentPayload(item, {
      calendarId: Number(this.beyanData.calendarId),
      nikahMemurKod: Number(this.beyanData.nikahMemurKod),
      kisiKod: Number(this.beyanData.kisiKod),
      evlenBeyanKod: Number(this.beyanData.evlenBeyanKod),
    });

    this.onDelete.emit(payload);
    this.tasks.store().remove(item.id);

    this.beyanData = {};
    this.selectedAppointment = null;
    this.repaintScheduler();
  }

  // -------------------- LOOKUP CHANGE --------------------
  itemChange($event: any) {
    this.beyanData.evlenBeyanKod = $event?.Kod;
  }

  itemChange3($event: any) {
    this.beyanData.kisiKod = $event?.Kod;
  }

  // -------------------- LIST SELECTION --------------------
  selectionChanged(item: any, isSelected: boolean) {
    const exists = this.selectedItems.some((i) => i.id === item.id);
    if (isSelected && !exists) this.selectedItems = [...this.selectedItems, item];
    if (!isSelected && exists)
      this.selectedItems = this.selectedItems.filter((i) => i.id !== item.id);

    this.applySelectionFilter();
  }

  toggleAllSelection() {
    const allItems = this.listDataSource.items() ?? [];
    const allSelected = this.selectedItems.length === allItems.length;
    this.setSelection(allItems, !allSelected);
  }

  private setSelection(items: any[], selectAll: boolean) {
    this.selectedItems = selectAll ? [...items] : [];
    this.selectAllButtonText =
      this.selectedItems.length === (this.listDataSource.items()?.length ?? 0)
        ? 'Tümünü Temizle'
        : 'Tümünü Seç';
    this.applySelectionFilter();
  }

  // DKM-5509 Cedric: eski hâli — yalnız salon seçimine göre süzüyordu
  // applySelectionFilter() {
  //   const selectedIds = this.selectedItems.map((x) => x.id);
  //   if (!selectedIds.length) {
  //     this.tasks.filter(null);
  //   } else {
  //     // ["calendarId","=",id1] or ["calendarId","=",id2] ...
  //     const filter: any[] = [];
  //     selectedIds.forEach((id, i) => {
  //       filter.push(['calendarId', '=', id]);
  //       if (i < selectedIds.length - 1) filter.push('or');
  //     });
  //     this.tasks.filter(filter);
  //   }
  //   this.tasks.reload();
  // }
  applySelectionFilter() {
    const selectedIds = this.selectedItems.map((x) => x.id);
    // ["calendarId","=",id1] or ["calendarId","=",id2] ... (hiç salon seçili değilse salon süzgeci yok — eski davranış)
    const salonFiltre: any[] = [];
    selectedIds.forEach((id, i) => {
      salonFiltre.push(['calendarId', '=', id]);
      if (i < selectedIds.length - 1) salonFiltre.push('or');
    });
    const memurFiltre = this.memurSuzgec != null ? ['nikahMemurKod', '=', this.memurSuzgec] : null;
    if (salonFiltre.length && memurFiltre) this.tasks.filter([salonFiltre, 'and', memurFiltre]);
    else if (salonFiltre.length) this.tasks.filter(salonFiltre);
    else this.tasks.filter(memurFiltre);
    this.tasks.reload();
  }

  /** DKM-5509 Cedric: memur süzgeci değişti. */
  memurSuzgecDegisti(kod: any) {
    this.memurSuzgec = kod ?? null;
    this.applySelectionFilter();
  }

  // -------------------- RENDER HELPERS --------------------
  repaintScheduler() {
    this.selectedAppointment = null;
    this.beyanData = {};
    setTimeout(() => this.schedulerRef?.instance.repaint(), 0);
  }

  // -------------------- MAPPING & DATE HELPERS --------------------
  private mapApiItemToTask(item: any) {
    const [startHour, startMinute] = (item.BaslamaSaat ?? '00:00')
      .split(':')
      .map(Number);
    const [endHour, endMinute] = (item.BitisSaat ?? '00:00')
      .split(':')
      .map(Number);

    const startDate = new Date(item.RezervTarih);
    startDate.setHours(startHour, startMinute);

    const endDate = new Date(item.RezervTarih);
    endDate.setHours(endHour, endMinute);
    const memur = this.listDataSourceMemur?.items?.find((m: any) => m.kod === item.NikahMemurKod)?.aciklama || '';
    const salon = this.listDataSourceSalon?.items?.find((s: any) => s.kod === item.SalonKod)?.aciklama || '';
    const start = startDate.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    const end = endDate.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    const descPart = item.description ? `${item.description} | ` : '';

    item.agentLabel = `${descPart}${start} - ${end} saatine ${memur} Memurun ${salon} salonunda randevusu vardır.`;
    item.salonLabel = salon;


    return {
      id: item.Kod,
      description: item.Aciklama,
      text: item.Aciklama,
      calendarId: item.SalonKod,
      startDate,
      endDate,
      nikahMemurKod: item.NikahMemurKod,
      kisiKod: item.KisiKod,
      yapilacakYer: item.YapilacakYer,
      evlenBeyanKod: item.EvlenBeyanKod,
      eskiKisiKod: item.EskiKisiKod,
      rezervTarih: item.RezervTarih,
      agentLabel: item.agentLabel,
      salonLabel: item.salonLabel,

    };
  }

  private mapApiListToTasks(list: any[]) {
    return list.map((item) => this.mapApiItemToTask(item));
  }

  private normalizeAppointmentDates(item: any) {
    const startDate = this.toDate(item.startDate);
    const endDate = this.toDate(item.endDate);
    return { ...item, startDate, endDate };
  }

  private toDate(d: any): Date {
    return d instanceof Date ? d : new Date(d);
  }

  private toRezervTarih(date: Date): string {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${day}T00:00:00`;
    // Not: rezervTarih saat 00:00:00 istenildiği için sabit
  }

  private toSaat(date: Date): string {
    const hh = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    return `${hh}:${mm}`;
  }

  private buildAppointmentPayload(
    item: any,
    overrides?: {
      calendarId?: number;
      nikahMemurKod?: number;
      kisiKod?: number;
      evlenBeyanKod?: number;
    }
  ) {
  const start = this.toDate(item.startDate);
  const end = this.toDate(item.endDate);

  const RezervTarih = this.toRezervTarih(start);
  const BaslamaSaat = this.toSaat(start);
  const BitisSaat = this.toSaat(end);

  const SalonKod =
    overrides?.calendarId ?? Number(item.calendarId ?? this.beyanData.calendarId);
  const NikahMemurKod =
    overrides?.nikahMemurKod ?? Number(item.nikahMemurKod ?? this.beyanData.nikahMemurKod);
  const KisiKod =
    overrides?.kisiKod ?? Number(item.kisiKod ?? this.beyanData.kisiKod);
  const EvlenBeyanKod =
    overrides?.evlenBeyanKod ?? Number(item.evlenBeyanKod ?? this.beyanData.evlenBeyanKod);

  const parsedKod = Number(item.id);
  const payload: any = {
    Kod: item.id, // geçici koyuyoruz, sonra kontrol edeceğiz
    SalonKod,
    RezervTarih,
    BaslamaSaat,
    BitisSaat,
    NikahMemurKod,
    YapilacakYer: item.yapilacakYer,
    EvlenBeyanKod,
    KisiKod,
    Aciklama: item.description,
    EskiKisiKod: item.eskiKisiKod,
  };

  // Eğer item.id sayıya dönüşmüyorsa (örn: GUID) Kod alanını kaldır
  if (!Number.isFinite(parsedKod)) {
    delete payload.Kod;
  } else {
    payload.Kod = parsedKod; // numeric hale getir
  }

  return payload;
}

}
